var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAgile = function SvgAgile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB366",
    d: "m49.612 24.51 1.36 6.406a.36.36 0 0 1-.312.43.36.36 0 0 1-.194-.036l-4.75-2.336a.364.364 0 0 1-.12-.55l3.387-4.07a.364.364 0 0 1 .63.156"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#agile_svg__paint0_linear_1463_7977)",
    d: "m49.909 29.838-.527-3.656a6.9 6.9 0 0 0 3.7-1.76 6.91 6.91 0 0 0 1.733-7.64 6.895 6.895 0 0 0-12.89.187 6.9 6.9 0 0 0-.202 4.098l-3.578.924a10.62 10.62 0 0 1 4.124-11.298 10.586 10.586 0 0 1 15.975 4.714A10.62 10.62 0 0 1 55.59 27.14a10.6 10.6 0 0 1-5.681 2.705z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB366",
    d: "M12.943 43.962a18.69 18.69 0 0 1 .877-25.9 18.64 18.64 0 0 1 8.214-4.643l-1.375 1.726 2.407 2.204a14.6 14.6 0 0 0-6.423 3.633 14.61 14.61 0 0 0-4.076 13.698 14.6 14.6 0 0 0 3.39 6.56z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB366",
    d: "M13.343 44.194c.15-.037 5.117 0 5.117 0l-2.504-2.954-3.015 2.721zM50.02 50.807v-6.554a.365.365 0 0 1 .578-.28l4.157 3.277a.356.356 0 0 1 0 .562l-4.157 3.277a.364.364 0 0 1-.578-.282"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB366",
    d: "M50.691 45.584H27.577v3.895h23.114z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#agile_svg__paint1_linear_1463_7977)",
    d: "M26.59 12.816v3.992a14.32 14.32 0 0 1 10.044 4.248 14.353 14.353 0 0 1 0 20.191 14.32 14.32 0 0 1-10.044 4.247H1v3.992h25.59c10.097 0 18.312-8.225 18.312-18.334S36.687 12.816 26.59 12.816"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB366",
    d: "m27.364 11.55-.013 6.554a.357.357 0 0 1-.577.28l-4.153-3.285a.357.357 0 0 1 0-.56l4.165-3.268a.356.356 0 0 1 .578.28"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#agile_svg__paint2_linear_1463_7977)",
    d: "M23.331 29.981a1.66 1.66 0 0 0-2.337 0 1.64 1.64 0 0 0 0 2.326l3.116 3.1c.323.322.746.482 1.169.482s.846-.16 1.168-.481l6.233-6.202a1.64 1.64 0 0 0 0-2.326 1.66 1.66 0 0 0-2.337 0l-5.064 5.04z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "agile_svg__paint0_linear_1463_7977",
    x1: 45.026,
    x2: 79.563,
    y1: 19.543,
    y2: -13.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB366",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "agile_svg__paint1_linear_1463_7977",
    x1: 14.182,
    x2: -25.891,
    y1: 54.606,
    y2: 27.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB366",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "agile_svg__paint2_linear_1463_7977",
    x1: 26.837,
    x2: 26.695,
    y1: 26.398,
    y2: 44.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};
export default SvgAgile;